import React, { useCallback, useEffect, useState } from 'react';
import { Painel } from '../../../../components/Painel';
import { useModal } from '../../../../hooks/modal';
import { SubscriptionData } from '../../../../modais/subscriptionData';
import { api } from '../../../../services/api';

import {
  CardSubscription,
  Container,
  ContainerSubscriptions,
  Info,
  ContainerWarnings,
  PageSubtitle,
  PageTitle,
} from './styles';

interface subscriptionProps {
  description: string;
  id: string;
  max_exercises: number | null;
  max_news: number | null;
  max_users: number | null;
  name: string;
  price: number;
}

interface currentSubscriptionProps {
  subscription: subscriptionProps;
}

const Subscriptions: React.FC = () => {
  const [subscriptions, setSubscriptions] = useState<subscriptionProps[]>([]);
  const [currentSubscription, setCurrentSubscription] =
    useState<currentSubscriptionProps | null>(null);

  const { addModal } = useModal();

  const getSubscriptions = useCallback(() => {
    api
      .get('subscriptions')
      .then(response => {
        const subs = response.data as subscriptionProps[];
        setSubscriptions(subs.filter(sub => sub.name !== 'test'));
      })
      .catch(err => console.log(err));
  }, []);

  const getCurrentSubscription = useCallback(() => {
    api
      .get('subscriptions/current')
      .then(response => setCurrentSubscription(response.data))
      .catch(() => setCurrentSubscription(null));
  }, []);

  useEffect(() => {
    getSubscriptions();
    getCurrentSubscription();
  }, [getSubscriptions, getCurrentSubscription]);

  const handleRefetch = useCallback(() => {
    getSubscriptions();
    getCurrentSubscription();
  }, [getSubscriptions, getCurrentSubscription]);

  return (
    <Painel>
      <Container>
        <PageTitle>Planos TRENZOX</PageTitle>
        <PageSubtitle>Escolha o plano ideal para a sua academia</PageSubtitle>

        <ContainerWarnings>
          <Info text="Selecione um dos nossos planos para ter acesso as nossas funcionalidades. " />
          <Info text="O plano atual da sua instituição, caso esteja assinado, estará em destaque. " />
          <Info text="Para fazer o upgrade do plano da sua instituição basta selecionar um plano superior ao atualmente em uso. " />
        </ContainerWarnings>

        <ContainerSubscriptions>
          {subscriptions.map(subscription => {
            const isCurrentPlan =
              subscription.id === currentSubscription?.subscription.id;
            const isDowngrade =
              !!currentSubscription &&
              !isCurrentPlan &&
              subscription.price < currentSubscription.subscription.price;

            return (
              <CardSubscription
                key={subscription.id}
                title={subscription.name.toUpperCase()}
                news={subscription.max_news}
                exercises={subscription.max_exercises}
                users={subscription.max_users}
                price={subscription.price}
                currentSubscription={isCurrentPlan}
                disabled={isCurrentPlan || isDowngrade}
                disabledLabel={
                  isCurrentPlan ? 'Plano atual' : 'Downgrade indisponível'
                }
                functionButton={() =>
                  addModal(
                    <SubscriptionData
                      subscription_id={subscription.id}
                      title={subscription.name}
                      news={subscription.max_news}
                      exercises={subscription.max_exercises}
                      users={subscription.max_users}
                      price={subscription.price}
                      onSuccess={handleRefetch}
                    />,
                  )
                }
              />
            );
          })}
        </ContainerSubscriptions>
      </Container>
    </Painel>
  );
};

export { Subscriptions };
